module.exports = __webpack_public_path__ + "img/left_dots_pattern.be84f42a.svg";